import type { FooterColPayment } from '../../../types/footer';
import type { Translations } from '../../../types/translations';

export const mapPayment = ({
  col,
  index,
  translations = {},
  instance,
}: {
  baseUrl?: string;
  col: FooterColPayment;
  index: number;
  translations?: Translations;
  instance?: string;
}) =>
  ({
    type: 'payment',
    id: index,
    items:
      col?.st_elements.value.at(0)?.st_items.value.map(({ st_title, st_image }) => ({
        label: st_title,
        id: st_title,
        image: st_image.resolutionsMetaData.ORIGINAL.url,
      })) ?? [],

    title:
      col?.st_headline ??
      translations?.[`footer.column.headline.${index + 1}${instance === 'shop' ? '.shop' : ''}`] ??
      '',
  }) as const;
